import { createStore } from 'vuex';
import ManageUser from '@/store/common/ManageUser';
import Notifications from '@/store/common/Notifications';
// API
import APISecurity from '@/store/API/Security';
import Inscription from '@/store/API/Inscription';
import Home from './API/Home';
import Stuff from './API/Stuff';

export default createStore({
  modules: {
    ManageUser,
    Notifications,
    APISecurity,
    Inscription,
    Home,
    Stuff,
  }
});